/**
 * formDeriveEntrySources
 *
 * The `source` members one entry declares, as a list — the single spelling of
 * "an algebraic entry is many-to-one and the other four arms carry a single
 * source". NOT the single spelling of "this read is a table cell": a row
 * projection's `source` is its partition key alone, and its columns read cells
 * this list never mentions. `detectFormDeriveCycle`'s `entrySourceCells` holds
 * that title, and every table-cell question belongs there.
 * Consumers: `detectFormDeriveCycle` (field source nodes),
 * `formDeriveEntryTableIds` (the fetch-superset rule) and the server
 * reconciler's referenceProp record fetch. `FormDeriveEntry` has no top-level
 * discriminant, so the algebraic arm is recognized by `'operands' in entry` —
 * never by a cast. A second spelling of this drifting from it is a missing graph
 * node, an unfetched table, or an unresolved reference.
 */

import type {
  FormDeriveColUniquesSource,
  FormDeriveEntry,
  FormDeriveScalarSource,
} from '../System.FormDerive.types';

function formDeriveEntrySources(
  entry: FormDeriveEntry,
): (FormDeriveScalarSource | FormDeriveColUniquesSource)[] {
  return 'operands' in entry ? entry.operands.map((operand) => operand.source) : [entry.source];
}

export { formDeriveEntrySources };
